import React from 'react';
import styled from 'styled-components';
import { stringify } from 'query-string';
import { getIn } from 'seamless-immutable';
import { LazyPicture } from '@catalogo/theme-lazy-picture';
import Loading from '@catalogo/ui-americanas-desktop-loading';
import { formatPrice } from '@catalogo/core-helpers/price';
import { withProduct } from '@catalogo/core-connect/product';
import { getImage } from '@catalogo/service-americanas-common/src/helpers/image';

const RecProduct = ({ product, pageType, hasRecommendations, position, loading, queryString }) => {
  const productId = getIn(product, ['id']);
  const { name, offers } = product || {};
  const { salesPrice } = getIn(offers, ['result', 0], {});
  const sources = {
    mobile: {
      src: getImage(getIn(product, ['images', 0], {}), 'small') || '',
      ratio: '1:1',
    },
    desktop: {
      src: getImage(getIn(product, ['images', 0], {}), 'small') || '',
      ratio: '1:1',
    },
  };

  const getPfmParams = () => {
    const params = {
      pfm_carac: name,
      pfm_page: pageType,
      pfm_pos: position,
      pfm_type: hasRecommendations ? 'vit_recommendation' : '',
    };
    return stringify(params);
  };

  const getOffer = product => getIn(product, ['offers', 'result', 0], {});

  const addOfferIdToQueryString = product => {
    const { offerId } = getOffer(product);
    return offerId ? `&offerId=${offerId}` : '';
  };

  const getLink = (queryString, product) => {
    const link = `/produto/${productId}?${getPfmParams()}&${queryString}${addOfferIdToQueryString(product)}`;
    return `${link}`;
  };

  return (
    <>
      {loading || !product ? (
        <Wrapper>
          <Loading position="relative" />
        </Wrapper>
      ) : (
        <Wrapper href={getLink(queryString, product)}>
          <Image>
            <LazyPicture sources={sources} errorPlaceholderSize="80px" alt={name} />
          </Image>

          <ProductData>
            <Name>{name || ''}</Name>
            <Price>{salesPrice ? `R$ ${formatPrice(salesPrice)}` : ''}</Price>
          </ProductData>
        </Wrapper>
      )}
    </>
  );
};

const Wrapper = styled.a`
  display: flex;
  flex-direction: row;
`;

const Image = styled.div`
  flex: 0 0 30%;
  margin-right: 10px;
`;

const ProductData = styled.div`
  display: flex;
  flex-direction: column;
`;

const Name = styled.div`
  color: ${({ theme }) => theme.grey.dark};
  font-size: 14px;
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  white-space: wrap;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  box-orient: vertical;
  -webkit-box-orient: vertical;
  height: 32px;
  width: 150px;
  margin-left: 10px;
`;

const Price = styled.div`
  padding: 10px;
  color: ${({ theme }) => theme.grey.darker};
  font-size: 18px;
  font-weight: bold;
`;

export default withProduct(RecProduct);
